// extracted by mini-css-extract-plugin
export var fadeIn = "_lx-1";
export var modalContent = "_lx-3";
export var overlay = "_lx-0";
export var popoverContent = "_lx-2";
export var results = "_lx-5";
export var searchInputWrapper = "_lx-4";